function getZIndex(elem) {
    var _a;
    if (!(elem instanceof Element))
        return undefined;
    var z = (_a = window.document.defaultView) === null || _a === void 0 ? void 0 : _a.getComputedStyle(elem).getPropertyValue("z-index");
    if (z === undefined)
        return undefined;
    var parsedZ = parseInt(z);
    if (isNaN(parsedZ) && elem.nodeName !== "HTML")
        return getZIndex(elem.parentNode);
    return isNaN(parsedZ) ? undefined : parsedZ;
}

export { getZIndex };
//# sourceMappingURL=getZIndex.js.map
